import {
  Button,
  Card,
  CardContent,
  Grid,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import React from "react";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { convertDateToCustomFormat } from "../../utils/commonUtils";
export default function CardEle({ item, callback, cbt }) {
  return (
    <Card
      onClick={() => {
        callback(item);
      }}
      sx={{
        cursor: "pointer",
        padding: "10px",
        backgroundColor: "#EEEEFF",
        "& .MuiCardContent-root": { p: "0rem" },
      }}
    >
      <CardContent sx={{ padding: "0rem 0.7rem !important" }}>
        <Grid container>
          <Grid item xs={12}>
            <Typography
              // color="primary"
              sx={{
                textAlign: "left",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },

                overflow: "Hidden",
                display: "-webkit-box",
                "-webkit-line-clamp": "1",
                "-webkit-box-orient": "vertical",
                fontWeight: 500,
                color: "primary.main",
              }}
            >
              {item?.message}
            </Typography>
          </Grid>

          <Grid item xs={12} sx={{ textAlign: "right" }}>
            {/* <Typography
              color="primary"
              sx={{
                textAlign: 'right',
                fontSize: "15px",
                overflow: "Hidden",
                display: "-webkit-box",
                "-webkit-line-clamp": "1",
                "-webkit-box-orient": "vertical",
                fontWeight: 600,
              }}
              onClick={(e) => {
                e.stopPropagation();
                cbt(item)
                console.log('clicked')
              }}
            >

              Click Here To Send!
            </Typography> */}
            <Button
              variant="contained"
              sx={{
                height: "40px",
                backgroundColor: "#14008B",
                fontSize: { xs: "10px", sm: "13px", md: "15px" },
                borderRadius: "8px",
              }}
              // endIcon={<AddIcon />}
              onClick={(e) => {
                e.stopPropagation();
                cbt(item);
                console.log("clicked");
              }}
            >
              Click here to send
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
